const Utils = require('relevant-shared/misc/tagUtils');

window.relevantDigital.export({ Utils });

module.exports = Utils;
